import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";
import { Divider } from '../components/Divider';

import cover from "../assets/img/bonsai.webp";
import { Container } from 'react-bootstrap';


export const projectDetails: ProjectInterface = {
    url: "drawings",
    title: "Drawings",
    summary: "A collection of some illustrations that I've made.",
    description: ``,
    year: "",
    tags: ["Illustrations", "Sketches", "2D", "Digital Painting"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    projectType: ProjectType.SIDE,
    videoSrc: "",
    isCoverType: false,
    haveTags: false,
    roles: ["Artist", "Hobby"],
    technologies: ["2D", "Krita", "Photoshop"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData:
        [
        ]
};


export function Drawings() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                    </div>
                }
                rightContent={
                    <div className="a-right-no-bg">
                    </div>
                }>

                <Container className="a-body">
                    <Divider width={100} />
                </Container>
            </ProjectBase>
        </div>
    );
}